import { LabelWeight } from '../components/Weight/Label';
import { AddMaterialButton } from '../containers/PCS/MonitorQueue/components';

export const productionQueueColumns = [
  {
    label: '#',
    value: '',
    mobile: true,
  },
  {
    label: (
      <div className="d-flex align-items-center justify-content-between">
        <span>Material Type</span>
        <AddMaterialButton />
      </div>
    ),
    value: 'materialType',
    minWidth: '138px',
    mobile: true,
  },
  {
    label: 'Minutes Before Stockout',
    value: 'minutesBeforeStockout',
  },
  {
    label: 'PCS\nBatch Size',
    value: 'batchSize',
    minWidth: '88px',
    styles: {
      whiteSpace: 'pre',
    },
  },
  {
    label: 'DLPS\nBatch Size',
    value: 'dlpsBatchSize',
    minWidth: '88px',
    styles: {
      whiteSpace: 'pre',
    },
  },
  {
    label: <LabelWeight label="Weight" />,
    value: 'weight',
    minWidth: '80px',
  },
  {
    label: 'Work Center',
    value: 'workCenter',
    className: 'col-max-w-1650',
  },
  {
    label: <LabelWeight label="Demand" />,
    value: 'demand',
    minWidth: '88px',
    className: 'col-max-w-1460',
  },
  {
    label: <LabelWeight label="Minute Demand" />,
    value: 'minuteDemand',
    minWidth: '88px',
    className: 'col-max-w-1560',
  },
  {
    label: 'Net Task Delay',
    value: 'netTaskDelay',
    endOfTable: true,
  },
  {
    label: 'Start Batch Prep',
    value: 'startBatchPrep',
    width: '11%',
    minWidth: '80px',
    maxWidth: '100px',
    className: 'col-progress-stage',
  },
  {
    label: 'Transfer Batch to Cooking Machine',
    value: 'transferBatchToCookingMachine',
    width: '11%',
    minWidth: '80px',
    maxWidth: '100px',
    className: 'col-progress-stage',
  },
  {
    label: 'Load Batch into Cooking Machine',
    value: 'loadBatchIntoCookingMachine',
    width: '11%',
    minWidth: '80px',
    maxWidth: '100px',
    className: 'col-progress-stage',
  },
  {
    label: 'Cook Cycle Started',
    value: 'cookCycleStarted',
    width: '11%',
    minWidth: '80px',
    maxWidth: '100px',
    className: 'col-progress-stage',
  },
  {
    label: 'Cook Cycle Complete',
    value: 'cookCycleComplete',
    width: '11%',
    minWidth: '80px',
    maxWidth: '100px',
    className: 'col-progress-stage',
  },
  {
    label: 'Batch Delivered to Hot Holding',
    value: 'batchDeliveredToHotHolding',
    width: '11%',
    minWidth: '80px',
    maxWidth: '100px',
    className: 'col-progress-stage',
  },
  {
    menu: true,
    label: '',
    value: 'menu',
    minWidth: '44px',
  },
];

export const cateringQueueColumns = [
  {
    label: 'Prod. Priority',
    value: 'priority',
    mobile: true,
  },
  {
    label: '#',
    value: 'batchNumber',
    mobile: true,
  },
  {
    label: 'Material Type',
    value: 'material',
  },
  {
    label: 'Batch size',
    value: 'batchSize',
    minWidth: '88px',
  },
  {
    label: 'Weight',
    value: 'weight',
    minWidth: '100px',
  },
  {
    label: 'Work Center',
    value: 'workCenter',
    className: 'col-max-w-1280',
  },
  {
    label: 'Net task delay',
    value: 'netTaskDelay',
    endOfTable: true,
  },
  {
    label: 'Start Batch Prep',
    value: 'startBatchPrep',
    width: '11%',
    minWidth: '80px',
  },
  {
    label: 'Transfer Batch to Cooking Machine',
    value: 'transferBatchToCookingMachine',
    width: '11%',
    minWidth: '80px',
  },
  {
    label: 'Load Batch into Cooking Machine',
    value: 'loadBatchIntoCookingMachine',
    width: '11%',
    minWidth: '80px',
  },
  {
    label: 'Cook Cycle Started',
    value: 'cookCycleStarted',
    width: '11%',
    minWidth: '80px',
  },
  {
    label: 'Cook Cycle Complete',
    value: 'cookCycleComplete',
    width: '11%',
    minWidth: '80px',
  },
  {
    label: 'Batch Delivered to Hot Holding',
    value: 'batchDeliveredToHotHolding',
    width: '11%',
    minWidth: '80px',
  },
  {
    label: 'Batch Complete',
    value: 'batchComplete',
    width: '11%',
    minWidth: '80px',
  },
];

export const futureQueueColumns = [
  {
    label: '#',
    value: '',
    mobile: true,
  },
  {
    label: 'Material Type',
    value: 'materialType',
    mobile: true,
  },
  {
    label: 'Scheduled Time',
    value: 'scheduledTime',
  },
  {
    label: 'Rest. Dep. Time',
    value: 'restaurantDepartureTime',
  },
  {
    label: 'Batch size',
    value: 'batchSize',
  },
  {
    label: 'Work Center',
    value: 'workCenter',
  },
  {
    label: 'Progress',
    value: 'progress',
    endOfTable: true,
  },
  {
    label: 'Waiting',
    value: 'waiting',
    width: '12%',
    minWidth: '72px',
  },
  {
    label: 'In Progress',
    value: 'inProgress',
    width: '12%',
    minWidth: '72px',
  },
  {
    label: 'Ready',
    value: 'ready',
    width: '12%',
    minWidth: '72px',
  },
];

export const tabletViewProductionQueueColumns = [
  {
    label: '#',
    value: '',
    mobile: true,
    width: '7%',
  },
  {
    label: 'Material Type',
    value: 'materialType',
    mobile: true,
    width: '15%',
  },
  {
    label: 'Minutes Before Stockout',
    value: 'minutesBeforeStockout',
    width: '8%',
  },
  {
    label: 'Batch Size',
    value: 'batchSize',
    width: '8%',
  },
  {
    label: 'Work Center',
    value: 'workCenter',
    width: '7%',
    endOfTable: true,
  },
  {
    label: 'Start Batch Prep',
    value: 'startBatchPrep',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Transfer Batch to Cooking Machine',
    value: 'transferBatchToCookingMachine',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Load Batch into Cooking Machine',
    value: 'loadBatchIntoCookingMachine',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Cook Cycle Started',
    value: 'cookCycleStarted',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Cook Cycle Complete',
    value: 'cookCycleComplete',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Batch Delivered to Hot Holding',
    value: 'batchDeliveredToHotHolding',
    width: '9%',
    minWidth: '80px',
  },
  {
    menu: true,
    label: '',
    value: 'minRowHeight',
    className: 'p-0',
  },
];

export const tabletViewCateringQueueColumns = [
  {
    label: 'Prod. Priority',
    value: 'priority',
    mobile: true,
    width: '5%',
  },
  {
    label: '#',
    value: 'batchNumber',
    mobile: true,
    width: '5%',
  },
  {
    label: 'Material Type',
    value: 'material',
    width: '14%',
  },
  {
    label: 'Batch size',
    value: 'batchSize',
    width: '6%%',
  },
  {
    label: 'Work Center',
    value: 'workCenter',
    width: '6%%',
    endOfTable: true,
  },
  {
    label: 'Start Batch Prep',
    value: 'startBatchPrep',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Transfer Batch to Cooking Machine',
    value: 'transferBatchToCookingMachine',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Load Batch into Cooking Machine',
    value: 'loadBatchIntoCookingMachine',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Cook Cycle Started',
    value: 'cookCycleStarted',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Cook Cycle Complete',
    value: 'cookCycleComplete',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Batch Delivered to Hot Holding',
    value: 'batchDeliveredToHotHolding',
    width: '9%',
    minWidth: '80px',
  },
  {
    label: 'Batch Complete',
    value: 'batchComplete',
    width: '9%',
    minWidth: '80px',
  },
];

export const statusValues = {
  BREADING_COMPLETE: 'BREADING_COMPLETE',
  GO: 'GO',
  CANCEL: 'CANCEL',
  WAIT: 'WAIT',
};

export const animationValues = {
  ACTIVATED: 'ACTIVATED',
  DELAYED: 'DELAYED',
  COMPLETED: 'COMPLETED',
  FLAT: 'FLAT',
};

export const friedStatusColors = [
  {
    id: 3,
    label: 'Breading Complete',
    value: statusValues.BREADING_COMPLETE,
    color: '#009408',
  },
  {
    id: 2,
    label: 'Go',
    value: statusValues.GO,
    color: '#DBB91D',
  },
  {
    id: 1,
    label: 'Cancelled',
    value: statusValues.CANCEL,
    color: '#CB444A',
  },
  {
    id: 0,
    label: 'Waiting',
    value: statusValues.WAIT,
    color: '#C2C2C2',
  },
];

export const grilledStatusColors = [
  {
    id: 3,
    label: 'Batch Prep Complete',
    value: statusValues.BREADING_COMPLETE,
    color: '#009408',
  },
  {
    id: 2,
    label: 'Go',
    value: statusValues.GO,
    color: '#DBB91D',
  },
  {
    id: 1,
    label: 'Cancelled',
    value: statusValues.CANCEL,
    color: '#CB444A',
  },
  {
    id: 0,
    label: 'Waiting',
    value: statusValues.WAIT,
    color: '#C2C2C2',
  },
];

export const emptyStage = {
  name: null,
  stage: 0,
};

export const prqStages = [
  {
    name: 'BREADING',
    stage: 1,
  },
  {
    name: 'BASKET_LOADING',
    stage: 2,
  },
  {
    name: 'BASKET_TRANSFER',
    stage: 3,
  },
  {
    name: 'BASKET_FRYING',
    stage: 4,
  },
  {
    name: 'CTS_TRANSFER',
    stage: 5,
  },
  {
    name: 'HOT_HOLDING_TRANSFER',
    stage: 6,
  },
];

export const prqStagesMap = prqStages.reduce((acc, stage) => {
  acc[stage.name] = stage.stage;
  return acc;
}, {});

export const prqDisabledStatuses = [statusValues.WAIT];

export const cateringPCSStages = [
  {
    name: 'BREADING',
    stage: 1,
  },
  {
    name: 'BASKET_LOADING',
    stage: 2,
  },
  {
    name: 'BASKET_TRANSFER',
    stage: 3,
  },
  {
    name: 'BASKET_FRYING',
    stage: 4,
  },
  {
    name: 'CTS_TRANSFER',
    stage: 5,
  },
  {
    name: 'HOT_HOLDING_TRANSFER',
    stage: 6,
  },
  {
    name: 'BATCH_COMPLETE',
    stage: 7,
  },
];

export const cateringStagesMap = cateringPCSStages.reduce((acc, stage) => {
  acc[stage.name] = stage.stage;
  return acc;
}, {});

export const stageProgressValues = {
  BEGIN: 'BEGIN',
  COMPLETED: 'COMPLETED',
};

export const queueTypes = [
  {
    label: 'On-Demand',
    value: 'production',
  },
  {
    label: 'Scheduled',
    value: 'catering',
  },
];
